import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonComponent } from '../common/button/components/button/button.component';
import { DividerComponent } from '../common/divider/divider.component';

@Component({
  selector: 'rt-thread-expander',
  templateUrl: './thread-expander.component.html',
  styleUrls: ['./thread-expander.component.less'],
  standalone: true,
  imports: [ButtonComponent, DividerComponent],
})
export class ThreadExpanderComponent {
  @Input() public text: string;

  @Output() public expand = new EventEmitter();
}
